// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.preview-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preview-header {
  margin-bottom: 8px;
}
.preview-header .preview-title {
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 18px;
  margin: 0 0 4px 0;
}
.preview-header .preview-subtitle {
  font-size: 13px;
  color: #8c8f93;
}

.preview-section {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.preview-section .section-header {
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 16px;
  text-align: left;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e3e3e3;
}
.preview-section .section-description {
  font-size: 13px;
  color: #8c8f93;
  margin: 0 0 12px 0;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 6px;
  font-size: 13px;
  border: 1px solid #e3e3e3;
}
.banner--compact {
  padding: 8px 12px;
}
.banner--error {
  background-color: rgba(151, 0, 46, 0.06);
  border-color: #97002e;
  color: #97002e;
}
.banner--warning {
  background-color: rgba(250, 171, 24, 0.15);
  border-color: #faab18;
  color: #e65100;
}
.banner--success {
  background-color: rgba(58, 158, 95, 0.1);
  border-color: #3a9e5f;
  color: #3a9e5f;
}
.banner--info {
  background-color: rgba(0, 102, 178, 0.05);
  border-color: #0066b2;
  color: #0b2d71;
}
.banner .banner-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.banner .banner-action {
  margin-left: auto;
}

.summary-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.summary-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-family: "GothamBold", Arial, sans-serif;
  border: 1px solid transparent;
}
.summary-chip mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.summary-chip--error {
  background-color: rgba(151, 0, 46, 0.08);
  border-color: #97002e;
  color: #97002e;
}
.summary-chip--warning {
  background-color: #fff3e0;
  border-color: #faab18;
  color: #e65100;
}
.summary-chip--ok {
  background-color: rgba(58, 158, 95, 0.1);
  border-color: #3a9e5f;
  color: #3a9e5f;
}
.summary-chip--busy {
  background-color: #e4f4fa;
  color: #0b2d71;
}
.summary-chip--zero {
  opacity: 0.55;
}

.issue-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}

.issue-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 6px 12px;
  background: none;
  border: none;
  border-bottom: 1px solid #e3e3e3;
  text-align: left;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
  cursor: pointer;
}
.issue-item:hover, .issue-item:focus-visible {
  background-color: #e4f4fa;
}
.issue-item .issue-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.issue-item--error {
  color: #97002e;
}
.issue-item--warning {
  color: #e65100;
}

.commit-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
}
.commit-overlay .commit-overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 32px;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  background-color: #fff;
  color: #0b2d71;
  text-align: center;
}

.upload-progress {
  margin-bottom: 12px;
}
.upload-progress .upload-progress-text {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #8c8f93;
}

.file-list {
  list-style: none;
  margin: 0 0 12px 0;
  padding: 0;
  max-height: 260px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 8px;
  border-bottom: 1px solid #e3e3e3;
}
.file-item--error {
  background-color: rgba(151, 0, 46, 0.05);
}
.file-item .file-state {
  display: inline-flex;
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
}
.file-item .state-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.file-item .state-icon--ok {
  color: #3a9e5f;
}
.file-item .state-icon--error {
  color: #97002e;
}
.file-item .state-icon--waiting {
  color: #8c8f93;
}
.file-item .file-text {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}
.file-item .file-name {
  font-size: 13px;
  color: #0b2d71;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-item .file-meta {
  font-size: 12px;
  color: #8c8f93;
}
.file-item .file-message {
  font-size: 12px;
  color: #97002e;
}
.file-item .file-message--warning {
  color: #e65100;
}

.file-empty {
  padding: 8px;
  font-size: 13px;
  color: #8c8f93;
}

.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px;
  border: 2px dashed #e3e3e3;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}
.drop-zone:hover {
  border-color: rgb(25, 156.797752809, 255);
  background-color: rgba(0, 102, 178, 0.02);
}
.drop-zone--active {
  border-color: #0066b2;
  background-color: rgba(0, 102, 178, 0.05);
}
.drop-zone--disabled {
  opacity: 0.5;
  pointer-events: none;
}
.drop-zone .drop-zone-icon {
  color: #0066b2;
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.drop-zone .drop-zone-text {
  font-size: 14px;
  color: #0b2d71;
}
.drop-zone .drop-zone-hint {
  font-size: 12px;
  color: #8c8f93;
  text-align: center;
}

.file-input-hidden {
  display: none;
}

.rows-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.rows-toolbar .section-header {
  flex: 1 1 auto;
}
.rows-toolbar .rows-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.button-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.table-scroll {
  max-height: 60vh;
  overflow: auto;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}

.index-table {
  width: 100%;
  min-width: max-content;
}
.index-table th.mat-mdc-header-cell {
  background-color: #e4f4fa;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 12px;
  white-space: nowrap;
}
.index-table th.mat-mdc-header-cell ::ng-deep .mat-sort-header-arrow {
  display: none;
}
.index-table th.mat-mdc-header-cell .sort-indicator {
  width: 18px;
  height: 18px;
  margin-left: 2px;
  font-size: 18px;
  vertical-align: middle;
  color: #8c8f93;
  opacity: 0.7;
}
.index-table th.mat-mdc-header-cell .sort-indicator[data-sort=ascending], .index-table th.mat-mdc-header-cell .sort-indicator[data-sort=descending] {
  color: #0066b2;
  opacity: 1;
}
.index-table td.mat-mdc-cell {
  padding: 2px 4px;
}
.index-table .col-status {
  width: 140px;
  min-width: 140px;
  padding: 0 8px;
}
.index-table .col-excel-row {
  width: 56px;
  min-width: 56px;
  padding: 0 8px;
  font-size: 12px;
  color: #8c8f93;
}
.index-table .col-actions {
  width: 40px;
  min-width: 40px;
  padding: 0 4px;
}
.index-table .required-mark {
  color: #97002e;
}

.cell-input {
  box-sizing: border-box;
  width: 100%;
  min-width: 130px;
  padding: 6px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
  color: #000000;
}
.cell-input:hover:not(:disabled) {
  border-color: #e3e3e3;
}
.cell-input:focus {
  outline: none;
  border-color: #0066b2;
  background-color: #ffffff;
}
.cell-input:disabled {
  color: #707070;
}

.cell--error .cell-input {
  border-color: #97002e;
  background-color: rgba(151, 0, 46, 0.06);
}

.cell--warning .cell-input {
  border-color: #faab18;
  background-color: rgba(250, 171, 24, 0.12);
}

.row--error {
  background-color: rgba(151, 0, 46, 0.03);
}

.row--warning {
  background-color: rgba(250, 171, 24, 0.06);
}

.row-status-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.row-status-icon--error {
  color: #97002e;
}
.row-status-icon--warning {
  color: #e65100;
}

.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  color: #8c8f93;
  cursor: pointer;
}
.icon-button:hover, .icon-button:focus-visible {
  color: #97002e;
}

.table-empty {
  padding: 16px;
  font-size: 13px;
  color: #8c8f93;
  text-align: center;
}

.preview-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

.banner-spinner,
.state-spinner {
  display: inline-block;
}

.section-header--toggle {
  padding-bottom: 0;
}
.section-header--toggle .section-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 0 0 8px 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.section-header--toggle .section-toggle:hover, .section-header--toggle .section-toggle:focus-visible {
  color: #0b2d71;
}
.section-header--toggle .section-toggle:focus-visible {
  outline: 2px solid #0066b2;
  outline-offset: 2px;
}
.section-header--toggle .section-toggle-icon {
  flex: 0 0 auto;
}

.section-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.review-ok {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  color: #3a9e5f;
}

.review-note {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 0 0;
  font-size: 13px;
  color: #8c8f93;
}

.review-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}

.review-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  border-bottom: 1px solid #e3e3e3;
  text-align: left;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
  cursor: pointer;
}
.review-item:hover, .review-item:focus-visible {
  background-color: #e4f4fa;
}
.review-item .review-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.review-item--error {
  color: #97002e;
}
.review-item--warning {
  color: #e65100;
}
.review-item--info {
  color: #0b2d71;
}

.activity-lines {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 8px 0 0 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  color: #0b2d71;
}

.row-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #8c8f93;
}
.row-status--error {
  color: #97002e;
}
.row-status--warning {
  color: #e65100;
}
.row-status .row-status-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.row-status .row-status-label {
  white-space: nowrap;
}

.file-cell {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 260px;
  max-width: 360px;
  padding: 4px 8px;
}

.file-cell-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.file-cell-name,
.file-cell-empty {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #000000;
}

.file-cell-empty {
  color: #8c8f93;
}

.file-cell-state {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #8c8f93;
}
.file-cell-state--ok {
  color: #3a9e5f;
}
.file-cell-state--problem {
  color: #97002e;
}
.file-cell-state .file-cell-state-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.file-cell-message,
.file-cell-shared {
  font-size: 12px;
  color: #8c8f93;
  white-space: normal;
}

.file-cell-message {
  color: #97002e;
}

.file-cell-actions {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
}

.file-item--warning {
  background-color: rgba(250, 171, 24, 0.12);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
